/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpServersListToolMetadata } from "../funcs/mcpServersListToolMetadata.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListToolMetadataResult } from "../models/components/listtoolmetadataresult.js";
import {
  ListMcpServerToolMetadataRequest,
  ListMcpServerToolMetadataSecurity,
} from "../models/operations/listmcpservertoolmetadata.js";
import { unwrapAsync } from "../types/fp.js";
export type ListMcpServerToolMetadataQueryData = ListToolMetadataResult;

export function prefetchListMcpServerToolMetadata(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListMcpServerToolMetadataRequest,
  security?: ListMcpServerToolMetadataSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListMcpServerToolMetadataQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListMcpServerToolMetadataQuery(
  client$: GramCore,
  request: ListMcpServerToolMetadataRequest,
  security?: ListMcpServerToolMetadataSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListMcpServerToolMetadataQueryData>;
} {
  return {
    queryKey: queryKeyListMcpServerToolMetadata({
      mcpServerId: request.mcpServerId,
      includeDeleted: request.includeDeleted,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function listMcpServerToolMetadataQueryFn(
      ctx,
    ): Promise<ListMcpServerToolMetadataQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpServersListToolMetadata(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListMcpServerToolMetadata(
  parameters: {
    mcpServerId: string;
    includeDeleted?: boolean | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpServers", "listToolMetadata", parameters];
}
